import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import SubscribeForm from './subscribe/SubscribeForm';
import SubscribeRadioTop from './subscribe/SubscribeRadioTop';
import SubscribeName from './subscribe/SubscribeName';
import SubscribeAddress from './subscribe/SubscribeAddress';
import SubscribeZip from './subscribe/SubscribeZip';
import SubscribeEmailAddress from './subscribe/SubscribeEmailAddress';
import SubscribeRequired from './subscribe/SubscribeRequired';
import SubscribeButton from './subscribe/SubscribeButton';
import SubscribeRadioBottom from './subscribe/SubscribeRadioBottom';
import UnsubscribeImage from './subscribe/UnsubscribeImage';
import UnsubscribeLeadEmail from './subscribe/UnsubscribeLeadEmail';
import UnsubscribeLeadMail from './subscribe/UnsubscribeLeadMail';
import UnsubscribeButton from './subscribe/UnsubscribeButton';
import { postData } from '../utility';

function Subscribe({ size, type }) {
  const [state, setState] = React.useState({
    email: '',
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    state: '',
    zip: ''
  });

  const [errors, setErrors] = React.useState({});

  const [complete, setComplete] = React.useState(false);

  function onChange(event) {
    event.preventDefault();
    const newState = Object.assign({}, state);
    newState[event.target.name] = event.target.value;
    setState(newState);
    if (errors[event.target.name]) {
      const newErrors = Object.assign({}, errors);
      delete newErrors[event.target.name];
      setErrors(newErrors);
    }
  }

  function onClick(event) {
    event.preventDefault();

    let action;
    let redirect;

    switch (type) {
      case 'mail':
        action = 'subscribe_mail';
        redirect = './SubscribeMailThanks';
        break;
      case 'email':
        action = 'subscribe_email';
        redirect = './SubscribeThanks';
        break;
      case 'both':
        action = 'subscribe_both';
        redirect = './SubscribeThanks';
        break;
      case 'mail_unsubscribe':
        action = 'unsubscribe_mail';
        redirect = './UnsubscribeThanks';
        break;
      case 'email_unsubscribe':
        action = 'unsubscribe_email';
        redirect = './UnsubscribeThanks';
        break;
      default:
    }

    setErrors({});
    postData('/api/subscription', {
      action,
      firstName: state.firstName,
      lastName: state.lastName,
      address: state.address,
      city: state.city,
      state: state.state,
      zip: state.zip,
      email: state.email,
      queryString: window.location.search ? window.location.search.slice(1) : ""
    })
      .then(data => {
        if (data.status === 'ok') {
          setComplete(redirect);
        } else {
          setErrors(data.errors);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function onClickRadio(event) {
    if (event.target.value) {
      switch (event.target.value) {
        case 'mail':
          setComplete('./SubscribeMail');
          break;
        case 'email':
          setComplete('./SubscribeEmail');
          break;
        case 'both':
          setComplete('./Subscribe');
          break;
        case 'mail_unsubscribe':
          setComplete('./UnsubscribeMail');
          break;
        case 'email_unsubscribe':
          setComplete('./UnsubscribeEmail');
          break;
        default:
      }
    }
  }

  if (complete) {
    return <Redirect push to={{ ...window.location, pathname: complete }} />;
  }

  switch (type) {
    case 'mail':
      return (
        <SubscribeForm size={size}>
          <SubscribeRadioTop size={size} type={type} onClickRadio={onClickRadio} />
          <SubscribeRequired size={size} />
          <SubscribeName size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeAddress size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeButton size={size} onClick={onClick} />
        </SubscribeForm>
      );
    case 'email':
      return (
        <SubscribeForm size={size}>
          <div className={`subscribe-${size}-radio-top`}>
            <div className={`subscribe-${size}-image`} />
          </div>
          <SubscribeRequired size={size} />
          <SubscribeName size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeZip size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeEmailAddress size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeButton size={size} onClick={onClick} />
          <hr className={`subscribe-${size}-border mt-5`} />
          <Link className="link" to="./Unsubscribe">Unsubscribe</Link>
        </SubscribeForm>
      );
    case 'both':
      return (
        <SubscribeForm size={size}>
          <SubscribeRadioTop size={size} type={type} onClickRadio={onClickRadio} />
          <SubscribeRequired size={size} />
          <SubscribeName size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeAddress size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeEmailAddress size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeButton size={size} onClick={onClick} />
          <SubscribeRadioBottom size={size} type={type} onClickRadio={onClickRadio} />
        </SubscribeForm>
      );
    case 'mail_unsubscribe':
      return (
        <SubscribeForm size={size}>
          <UnsubscribeImage size={size} />
          <UnsubscribeLeadMail size={size} />
          <SubscribeRequired size={size} />
          <SubscribeName size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeAddress size={size} state={state} errors={errors} onChange={onChange} />
          <UnsubscribeButton size={size} onClick={onClick} />
        </SubscribeForm>
      );
    case 'email_unsubscribe':
      return (
        <SubscribeForm size={size}>
          <UnsubscribeImage size={size} />
          <UnsubscribeLeadEmail size={size} />
          <SubscribeRequired size={size} />
          <SubscribeName size={size} state={state} errors={errors} onChange={onChange} />
          <SubscribeEmailAddress size={size} state={state} errors={errors} onChange={onChange} />
          <UnsubscribeButton size={size} onClick={onClick} />
        </SubscribeForm>
      );
    default:
  }
}

export default Subscribe;
